import { getIdentityClient } from "./axiosClients";

const identityClient = getIdentityClient();

export const identityApi = {
    login: async (username, password) => {
        const body = new URLSearchParams({ username, password });

        const res = await identityClient.post("/api/auth/login", body, {
            auth: false, // explicitně bez auth
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
        });

        return res.data;
    },

    register: async (email) => {
        const res = await identityClient.post("/api/auth/register", { email }, { auth: false });
        return res.data;
    },

    forgotPassword: async (email) => {
        const res = await identityClient.post("/api/auth/forgot-password", { email }, { auth: false });
        return res.data;
    },

    resetPassword: async (resetToken, password, confirmPassword) => {
        const res = await identityClient.post(
            `/api/auth/reset-password/${resetToken}`,
            { password, confirm_password: confirmPassword },
            { auth: false }
        );
        return res.data;
    },

    setupPassword: async (setupToken, password, confirmPassword) => {
        const res = await identityClient.post(
            `/api/auth/setup-password/${setupToken}`,
            { password, confirm_password: confirmPassword },
            { auth: false }
        );
        return res.data;
    },

    verifyEmail: async (token) => {
        const res = await identityClient.get(`/api/auth/verify/${token}`, { auth: false });
        return res.data;
    },
};
